import React, { useState } from 'react'

import { Typography, TextField, Button, Divider, Grid } from '@material-ui/core'
import { requestPasswordReset } from 'firebase/callables'
import AuthCard from './AuthCard'
import { useSnackContext } from 'samosas'
import GoogleLogo from 'assets/google-icon.svg'
import { handleGoogleAuth } from './utils'
import { auth, analytics } from '../../firebase'

export default function SignInView() {
  const snack = useSnackContext()
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const ForgotPasswordButton = () => (
    <Button
      onClick={() => {
        window.location.href = `/forgotPassword?email=${email}`
      }}
      size={'small'}
    >
      Forgot password?
    </Button>
  )

  return (
    <AuthCard height={520} loading={loading}>
      <Typography variant="overline">sign in with email</Typography>

      <TextField
        label={'Email Address'}
        name={'email'}
        type="email"
        value={email}
        onChange={e => {
          setEmail(e.target.value)
        }}
      />
      <TextField
        label={'Password'}
        name={'password'}
        type="password"
        value={password}
        onChange={e => {
          setPassword(e.target.value)
        }}
      />
      <Grid item>
        <ForgotPasswordButton />
      </Grid>

      <Button
        fullWidth
        variant="contained"
        size="large"
        onClick={async () => {
          try {
            setLoading(true)
            const authUser = await auth.signInWithEmailAndPassword(
              email,
              password
            )
            analytics.logEvent('login', {
              method: authUser.credential?.signInMethod,
            })
            window.location.replace('/')
            setLoading(false)
          } catch (error) {
            setLoading(false)
            if (error.code === 'auth/wrong-password') {
              snack.open({
                message: `Incorrect password, or you might be using a Google account`,
                action: <ForgotPasswordButton />,
              })
            } else {
              snack.open({ message: error.message })
            }
          }
        }}
      >
        SIGN IN WITH email
      </Button>

      <Typography variant="overline" align="center">
        or
      </Typography>

      <Button
        onClick={() => {
          setLoading(true)
          handleGoogleAuth(
            () => {
              setLoading(false)
              window.location.replace('/')
            },
            error => {
              setLoading(false)

              snack.open({ message: error.message })
            }
          )
        }}
        color="primary"
        size="large"
        variant="outlined"
        startIcon={
          <img
            src={GoogleLogo}
            width={16}
            height={16}
            style={{ marginRight: 8, display: 'block' }}
          />
        }
      >
        Sign in with Google
      </Button>
    </AuthCard>
  )
}
